<ng-content select=".message" />
<form data-test="select-organisation-form" [formGroup]="form">
	<fieldset>
		<pv-input
			autocapitalize="off"
			autocomplete="on"
			data-test="organisation-input"
			formControlName="organisation"
			icon="fa fa-building"
			label="{{ 'general.titles.organisation' | translate }}"
			placeholder="{{ 'general.titles.organisation' | translate }}"
			type="text"
			[class.error]="shouldShowError"
		>
			@if (shouldShowError) {
				<p class="errors" [innerHtml]="errorLabelForInput | translate"></p>
			}
		</pv-input>

		<div class="button">
			<ui-button
				data-test="select-organisation-button"
				[disabled]="loading"
				[icValidateForms]="[form]"
				[loading]="loading"
				[onlyWhenDirty]="false"
				(confirm)="submit()"
				>{{ "actions.select_organisation" | translate }}</ui-button
			>
		</div>
	</fieldset>
</form>
